<template lang="pug">
  .modal.modal--md.awards-modal
    h2.modal__title Портфолио
    .modal__text
    .modal__form
      .form
        .form__elem
          .form-elem.form-elem_horizontal
            .form-elem__title Наименование
            .form-elem__main
              .input {{award.title}}
        .form__elem
          .form-elem.form-elem_horizontal
            .form-elem__title Тип
            .form-elem__main
              .input {{awardType}}
        .form__elem
          .form-elem.form-elem_horizontal
            .form-elem__title Место
            .form-elem__main
              .input {{awardPlaces}}
              <!--.input 333-->
        .form__elem
          .form-elem.form-elem_horizontal
            .form-elem__title Год
            .form-elem__main
              .input {{award.year}}
        .form__elem
          .form-elem.form-elem_horizontal
            .form-elem__title Копия
            .form-elem__main
              .attach-file
                .attach-file__list
                  .attach-file__item(
                  v-for="file in award.attachments"
                  )
                    .attached-file
                      a.button(
                      download="true"
                      :href="file.file"
                      )
                        .button__icon
                          img(src="@/assets/images/icons/doc.svg")
                        .button__text {{ file.name }}
</template>
<script>
// import AttachFile from "../../../components/attach-file/attach-file";

export default {
  name: "awards-read-only",
  props: {
    modalData: {
      type: Object,
      default: () => ({}),
    },
  },
  /*data() {
    return {
      award: {
        title: ""
      }
    }
  },*/
  computed: {
    award() {
      return this.modalData.currentAward;
    },
    awardType() {
      let type = this.modalData.awardTypes.find(
        (item) => item.id === this.award.type.id
      );
      return type ? type.title : "";
    },
    awardPlaces() {
      return this.award.place.title;
    },
  },
};
</script>
